module.exports = __webpack_public_path__ + "static/media/door.13ca6aa1.gif";